import React from 'react';
import classNames from 'classnames';

import css from './Icon.module.scss';

interface Props {
  type: string;
  className?: string;
  width?: number;
  height?: number;
  color?: string;
  secondaryColor?: string;
  onClick?: (event: React.MouseEvent) => void;
}

const Icon = ({ type, className, width, height, color = '#000', secondaryColor, onClick, ...iconProps }: Props) => {
  let icon = null;
  const svgProps = {
    width,
    height,
    viewBox: `0 0 ${width || 38} ${height || 38}`,
    xmlns: 'http://www.w3.org/2000/svg',
  };

  switch (type) {
    case 'share':
      icon = (
        <svg {...svgProps} width="18px" height="19px" viewBox="0 0 18 19">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-26.000000, -25.000000)" fill="#FFFFFF">
              <g transform="translate(19.000000, 16.000000)">
                <g transform="translate(0.000000, 1.000000)">
                  <path d="M18.9071445,21.0668198 L13.2835484,17.9733159 C13.3708825,17.6968823 13.4182477,17.4037144 13.4182477,17.0999998 C13.4182477,16.7961441 13.3708461,16.5028707 13.2834027,16.2262613 L18.9068895,13.1328629 C19.4752718,13.727109 20.2885685,14.1000465 21.1909483,14.1000465 C22.9056775,14.1000465 24.2999994,12.7545114 24.2999994,11.0999528 C24.2999994,9.44553491 22.9056775,8.09999979 21.1909483,8.09999979 C19.4762191,8.09999979 18.0818972,9.44553491 18.0818972,11.0999528 C18.0818972,11.3449216 18.1131582,11.5828591 18.170798,11.8109528 L12.4707617,14.9465387 C11.9108323,14.4230973 11.1486171,14.1000465 10.3090509,14.1000465 C8.59446744,14.1000465 7.19999981,15.445441 7.19999981,17.0999998 C7.19999981,18.7545229 8.59446744,20.0999526 10.3090509,20.0999526 C11.1487264,20.0999526 11.9110874,19.7767964 12.4710168,19.2532143 L18.1709073,22.3886596 C18.1131947,22.6168588 18.0818972,22.8549017 18.0818972,23.1000463 C18.0818972,24.7544642 19.4762191,26.0999998 21.1909483,26.0999998 C22.9056775,26.0999998 24.2999994,24.7544642 24.2999994,23.1000463 C24.2999994,21.4454877 22.9056775,20.0999526 21.1909483,20.0999526 C20.2887143,20.0999526 19.4755633,20.4727846 18.9071445,21.0668198 Z"></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
      break;
    case 'closePopUp':
      icon = (
        <svg width="34.041" height="34.041" viewBox="0 0 34.041 34.041">
          <path
            d="M1.028-19.4h11.02v2.082H1.028v10.97h-2.082v-10.968h-10.968V-19.4h10.968v-11.02h2.082z"
            transform="rotate(45 -34.219 19.85)"
            fill="#e31b23"
          />
        </svg>
      );
      break;
    default:
      break;
  }

  return (
    <i className={classNames(css.icon, className)} {...iconProps} onClick={onClick}>
      {icon}
    </i>
  );
};

Icon.defaultProps = {
  className: '',
  width: 38.945,
  height: 38.948,
  color: '#111',
  secondaryColor: '#000',
  onClick: () => null,
};

export default Icon;
